import { useQuery } from "@tanstack/react-query";
import { MessageType, MessageStatus } from "@moonscape/shared";

export function useWebSocketDownloadTaxReport({
  year,
  mode,
}: {
  year: number;
  mode: string;
}) {
  const query = useQuery({
    queryKey: [MessageType.DOWNLOAD_TAX_REPORT, year?.toString(), mode],
    queryFn: async () => null,
    enabled: false,
  });

  const isLoading = query?.data?.status === MessageStatus.PROCESSING;

  return {
    ...query,
    data: query?.data?.responseMessage,
    isQueryLoading: isLoading,
  };
}
